export default "__VITE_ASSET__393c1e19__"